// Highway
import Highway from '@dogstudio/highway';

export default class DefaultPageTransition extends Highway.Transition {

  in({ from, to, trigger, done }) {

    const Loader = document.querySelector('.Loader');
    const h1 = document.querySelector('h1');
    // const loaderLogo = document.querySelector('.pimkie-logo');

    // Remove Last Page
    //if (window.DEVMODE) console.log('Leaving Page : ', from);
    from.parentNode.removeChild(from);

    // Timeline animation page enter
    const pageIn = new TimelineMax({
      paused: true,
      onStart: () => {

        document.body.classList.remove('is-loading');
      },
      onComplete: () => {
        document.body.classList.remove('is-animating');
        Loader.classList.remove("red");
        Loader.classList.remove("blue");
        Loader.classList.remove("purple");
        Loader.classList.remove("yellow");
        Loader.classList.remove("green");
        done();
      }
    });

    // pageIn.fromTo(Loader.querySelector('.inner'), 0.2, { y: 0 }, { y: '75%', ease: Power3.easeInOut, clearProps: 'all' }, 0);
    pageIn.fromTo(Loader, 1, { y: 0 }, { y: '-100%', ease: Power3.easeInOut, clearProps: 'all' }, 0);
    pageIn.fromTo(to, 0.2, { opacity: 0, y: 100 }, { opacity: 1, y: 0, ease: Power3.easeInOut, clearProps: 'all' }, 0);
    pageIn.fromTo(Loader.querySelector('.pimkie-logo .pi'), 1, { y: "0px" }, { y: '-250px', ease: Power3.easeInOut, clearProps: 'all' }, 0);
    pageIn.fromTo(Loader.querySelector('.pimkie-logo .mk'), 1, { y: "0px" }, { y: '-450px', ease: Power3.easeInOut, clearProps: 'all' }, 0);
    pageIn.fromTo(Loader.querySelector('.pimkie-logo .ie'), 1, { y: "0px" }, { y: '-750px', ease: Power3.easeInOut, clearProps: 'all' }, 0);

    // If strong el in the title : load animation
    if (document.querySelector('h1 strong')) {
      pageIn.fromTo(document.body.querySelector("h1 strong"), 0.35, { clipPath: "inset(0% 100% 0% 0%)", webkitClipPath: "inset(0% 100% 0% 0%)" }, { clipPath: "inset(0% 0% 0% 0%)", webkitClipPath: "inset(0% 0% 0% 0%)", ease: Power2.easeInOut }, 1.4);
    }
    // If em-anim className exists : load animation
    if (document.querySelector('h1 .em-anim')) {
      pageIn.fromTo(document.body.querySelector("h1 .em-anim"), 0.3, { clipPath: "inset(0% 100% 0% 0%)", webkitClipPath: "inset(0% 100% 0% 0%)" }, { clipPath: "inset(0% 0% 0% 0%)", webkitClipPath: "inset(0% 0% 0% 0%)", ease: Power2.easeInOut }, 1.5);
    }

    pageIn.play();

  }

  out({ from, trigger, done }) {

    const Loader = document.querySelector('.Loader');

    // Timeline animation page leave
    const pageOut = new TimelineMax({
      paused: true,
      onStart: () => {
        document.body.classList.add('is-loading');
        document.body.classList.add('is-animating');
        var colorsList = [
          "red",
          "blue",
          "purple",
          "yellow",
          "green"
        ];
        var loaderColor = colorsList[Math.floor(Math.random()*colorsList.length)];
        Loader.classList.add(loaderColor);
        var loaderLeft = (Math.floor(Math.random() * 60) + 1) - 30 ;
        Loader.querySelector('.pimkie-logo').style.left = loaderLeft+"%";

      },
      onComplete: () => {
        done();
      }
    });

    pageOut.fromTo(Loader.querySelector('.inner'), 1, { y: '-75%' }, { y: '0%', ease: Power3.easeInOut }, 0);
    pageOut.fromTo(Loader, 1, { y: '100%' }, { y: '0%', ease: Power3.easeInOut }, 0);
    pageOut.fromTo(Loader.querySelector('.pi'), 1, { y: '200%' }, { y: '0%', ease: Power3.easeInOut }, 0);
    pageOut.fromTo(Loader.querySelector('.mk'), 1, { y: '400%' }, { y: '0%', ease: Power3.easeInOut }, 0);
    pageOut.fromTo(Loader.querySelector('.ie'), 1, { y: '600%' }, { y: '0%', ease: Power3.easeInOut }, 0);
    pageOut.to(from, 1, { opacity: 0, y: -20, ease: Power3.easeInOut, clearProps: 'all' }, 0);

    pageOut.play();

  }

}
